import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  resetSnack,
  successSnack,
  errorSnack,
} from "../snackbar/snackbarSlice";
import { fetchOrderUserByID } from "../users/usersSlice";

import axios from "axios";
import {buildOrderDateRange} from "../../common/utils";
import {useState} from "react";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/orders${args.query}`,
        config
      );
      thunkAPI.dispatch(setOrdersAmount(response.headers["x-total-count"]));
      thunkAPI.dispatch(setLastQuery(args.query));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Orders list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientOrders = createAsyncThunk(
  "orders/fetchClientOrders",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/orders?${args.query}`,
        config
      );
      // thunkAPI.dispatch(setOrdersAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Orders list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreOrders = createAsyncThunk(
  "orders/fetchMoreOrders",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/orders${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setOrdersAmount(response.headers["x-total-count"]));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const filterClientOrders = createAsyncThunk(
  "orders/filterClientOrders",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/orders?${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Orders list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientOrderByID = createAsyncThunk(
  "orders/fetchClientOrderByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/orders/${args.orderID}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching order data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchOrderByID = createAsyncThunk(
  "orders/fetchOrderByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/orders/${args.orderID}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching order data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientUserOrders = createAsyncThunk(
  "orders/fetchClientUserOrders",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/users/${args.userID}/orders`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching order data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientUserOrderByID = createAsyncThunk(
  "orders/fetchClientUserOrderByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/users/${args.userID}/orders/${args.orderID}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching order data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createOrder = createAsyncThunk(
  "orders/createOrder",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.post(
        `${baseURL}/v1/admin/clients/${args.clientID}/orders`,
        args.order,
        config
      );
      thunkAPI.dispatch(successSnack("Order created successfully"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating Order"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateOrderDetails = createAsyncThunk(
  "orders/updateOrderDetails",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.patch(
        `${baseURL}/v1/admin/clients/${args.clientID}/orders/${args.orderID}`,
        args.order,
        config
      );
      thunkAPI.dispatch(
        fetchOrders({
          token: args.token,
          query: `?clients=${args.clientID}&limit=25&sort=desc`,
        })
      );
      thunkAPI.dispatch(successSnack("Order updated successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating order"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateOrderProduct = createAsyncThunk(
  "orders/updateOrderProduct",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.patch(
        `${baseURL}/v1/admin/clients/${args.clientID}/orders/${args.orderID}/products/${args.productID}`,
        args.product,
        config
      );
      // thunkAPI.dispatch(
      //   fetchClientOrders({
      //     token: args.token,
      //     clientID: args.clientID,
      //     query: '',
      //   })
      // );
      thunkAPI.dispatch(successSnack("Order updated successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating order"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const processOrders = createAsyncThunk(
  "orders/processOrders",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const daterange = buildOrderDateRange(args.startDate, args.endDate);

      const response = await axios.post(
        `${baseURL}/v1/admin/clients/${args.clientID}/invoices?odate=${daterange}`,
        {},
        config
      );
      thunkAPI.dispatch(resetSnack());
      if (response.data.msg === "no orders to process") {
        thunkAPI.dispatch(successSnack("No pending orders to process"));
      } else {
        thunkAPI.dispatch(successSnack("Orders processed successfully"));
        thunkAPI.dispatch(
          fetchOrders({
            token: args.token,
            query: `?clients=${args.clientID}&limit=25&sort=desc`,
          })
        );
      }

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(errorSnack("Unable to generate invoices"));
      }
      // console.log('error', error.response.data)
      return thunkAPI.rejectWithValue({
        error: error.response.data.error_description,
      });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreOrders(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    order: {},
    ordersList: [],
    ordersFilter: [],
    orderUser: {},
    loading: "idle",
    message: "",
    error: "",
    orderAccount: {},
    editing: false,
    ordersAmount: "",
    lastQuery: "",
  },
  reducers: {
    setOrder(state, action) {
      state.order = action.payload;
    },
    setEditing(state, action) {
      state.editing = action.payload;
    },
    setOrderUser(state, action) {
      state.orderUser = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = "loaded";
    },
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setOrdersAmount: (state, action) => {
      state.ordersAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClientOrders.pending, (state) => {
      state.ordersList = [];
      state.ordersFilter = [];

      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchClientOrders.fulfilled, (state, { payload }) => {
      state.ordersList = payload;
      state.ordersFilter = payload;
      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchClientOrders.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreOrders.fulfilled, (state, { payload }) => {
      state.error = "";
      state.ordersList = state.ordersList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreOrders.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.ordersList = state.ordersList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchOrders.pending, (state) => {
      state.ordersList = [];
      state.ordersFilter = [];

      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchOrders.fulfilled, (state, { payload }) => {
      state.ordersList = payload;
      state.ordersFilter = payload;
      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchOrders.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchClientUserOrders.pending, (state) => {
      state.ordersList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchClientUserOrders.fulfilled, (state, { payload }) => {
      state.ordersList = payload;
      state.ordersFilter = payload;
      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchClientUserOrders.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchClientOrderByID.pending, (state) => {
      state.order = {};
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchClientOrderByID.fulfilled, (state, { payload }) => {
      state.order = payload;
      state.loading = "loaded";
      state.editing = true;
    });
    builder.addCase(fetchClientOrderByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchOrderByID.pending, (state) => {
      state.order = {};
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchOrderByID.fulfilled, (state, { payload }) => {
      state.order = payload;
      state.loading = "loaded";
      state.editing = true;
    });
    builder.addCase(fetchOrderByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchClientUserOrderByID.pending, (state) => {
      state.order = {};
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(
      fetchClientUserOrderByID.fulfilled,
      (state, { payload }) => {
        state.order = payload;
        state.loading = "loaded";
        state.editing = true;
      }
    );
    builder.addCase(fetchClientUserOrderByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });

    builder.addCase(filterClientOrders.pending, (state) => {
      state.ordersFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(filterClientOrders.fulfilled, (state, { payload }) => {
      state.ordersFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(filterClientOrders.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createOrder.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createOrder.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createOrder.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchOrderUserByID.pending, (state) => {
      state.orderUser = {};
      state.editing = false;
    });
    builder.addCase(fetchOrderUserByID.fulfilled, (state, { payload }) => {
      state.orderUser = payload;
      state.editing = true;
    });
    builder.addCase(fetchOrderUserByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(processOrders.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.payload.error;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  setOrder,
  setOrderUser,
  setEditing,
  setError,
  setLastQuery,
  setOrdersAmount,
} = ordersSlice.actions;

export const selectOrders = createSelector(
  (state) => ({
    orders: state.orders,
    ordersList: state.orders.ordersList,
    ordersFilter: state.orders.ordersFilter,
    loading: state.orders.loading,
    error: state.orders.error,
    editing: state.orders.editing,
    order: state.orders.order,
    orderUser: state.orders.orderUser,
    ordersAmount: state.orders.ordersAmount,
    lastQuery: state.orders.lastQuery,
  }),
  (state) => state
);
export default ordersSlice.reducer;
